var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDiscover(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "72px",
    height: "48px",
    viewBox: "0 0 72 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "mdpi/Tender_discovery") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0.0008 0 72 0 72 47.9996 0.0008 47.9996"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-3",
    points: "0.7048 0.049 56 0.049 56 20 0.7048 20"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-5",
    points: "0 48 72 48 72 0 0 0"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Tender_discovery",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-13"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.0008,35.5716 L72.0008,23.9996 L72.0008,12.4276 L72.0008,3.9176 C72.0008,1.7536 70.2448,-0.0004 68.0808,-0.0004 L51.1788,-0.0004 L39.1788,-0.0004 L3.9188,-0.0004 C1.7548,-0.0004 0.0008,1.7536 0.0008,3.9176 L0.0008,12.4856 L0.0008,23.9996 L0.0008,35.5156 L0.0008,44.0816 C0.0008,46.2456 1.7548,47.9996 3.9188,47.9996 L38.8968,47.9996 L50.8968,47.9996 L68.0808,47.9996 C70.2448,47.9996 72.0008,46.2456 72.0008,44.0816 L72.0008,35.5716 Z",
    id: "Fill-1",
    fill: "#E6E6E6",
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(16.000000, 28.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.0008,0.049 C56.0008,0.049 36.4688,13.829 0.7048,20.001 L52.1508,20.001 C54.2768,20.001 56.0008,18.277 56.0008,16.151 L56.0008,0.049 Z",
    id: "Fill-4",
    fill: "#FCA468",
    mask: "url(#mask-4)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M13.0788,5.9904 L6.9188,5.9904 L6.9188,27.4764 L13.0448,27.4764 C16.2948,27.4764 18.6508,26.7044 20.7088,24.9944 C23.1588,22.9664 24.6068,19.9064 24.6068,16.7424 C24.6068,10.4004 19.8728,5.9904 13.0788,5.9904 M17.9748,22.1264 C16.6488,23.3224 14.9488,23.8384 12.2388,23.8384 L11.1088,23.8384 L11.1088,9.6284 L12.2388,9.6284 C14.9488,9.6284 16.5868,10.1124 17.9748,11.3684 C19.4248,12.6564 20.2888,14.6524 20.2888,16.7124 C20.2888,18.7784 19.4248,20.8444 17.9748,22.1264",
    id: "Fill-7",
    fill: "#253338"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-6",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-10"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-9",
    fill: "#253338",
    mask: "url(#mask-6)",
    points: "26.542 27.476 30.732 27.476 30.732 5.99 26.542 5.99"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.9774,14.2326 C38.4654,13.3006 37.7254,12.6846 37.7254,11.5306 C37.7254,10.1766 39.0374,9.1446 40.8494,9.1446 C42.1034,9.1446 43.1354,9.6586 44.2314,10.8806 L46.4234,8.0186 C44.6174,6.4346 42.4634,5.6306 40.1034,5.6306 C36.3094,5.6306 33.4074,8.2746 33.4074,11.7806 C33.4074,14.7506 34.7594,16.2606 38.6894,17.6826 C40.3334,18.2586 41.1694,18.6466 41.5934,18.9086 C42.4294,19.4566 42.8454,20.2266 42.8454,21.1286 C42.8454,22.8686 41.4594,24.1566 39.5894,24.1566 C37.5954,24.1566 35.9854,23.1586 35.0174,21.2906 L32.3114,23.9026 C34.2434,26.7346 36.5634,27.9946 39.7554,27.9946 C44.1014,27.9946 47.1634,25.0926 47.1634,20.9386 C47.1634,17.5206 45.7494,15.9746 40.9774,14.2326",
    id: "Fill-11",
    fill: "#253338",
    mask: "url(#mask-6)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.4832,16.7434 C48.4832,23.0634 53.4452,27.9594 59.8232,27.9594 C61.6272,27.9594 63.1772,27.6034 65.0812,26.7034 L65.0812,21.7734 C63.4012,23.4494 61.9192,24.1234 60.0192,24.1234 C55.7992,24.1234 52.7992,21.0634 52.7992,16.7114 C52.7992,12.5914 55.8912,9.3354 59.8232,9.3354 C61.8232,9.3354 63.3392,10.0454 65.0812,11.7514 L65.0812,6.8214 C63.2472,5.8894 61.7232,5.5054 59.9232,5.5054 C53.5752,5.5054 48.4812,10.4994 48.4832,16.7434",
    id: "Fill-12",
    fill: "#253338",
    mask: "url(#mask-6)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscover);
export default __webpack_public_path__ + "assets/media/discover.3f3f27d25a38978130a9313391ec8579.svg";
export { ForwardRef as ReactComponent };